import { useContext, useRef, useState } from "react";
import DynamicForm from "../../../components/DynamicForm/DynamicForm";
import { UserContext } from "../../../context/UserContext";

import { text_validation, email_validation, UseValidation, phone_validation } from "../../../components/DynamicForm/Helpers/validationMethods";
import { format_phone } from "../../../components/DynamicForm/Helpers/formattingMethods";
import { formatPhoneNumber } from "../../../utils/genericUtils";

const defaultProps = {
  onChanged: () => {},
};

export default function AccountSettings(props = defaultProps) {
  const { user, loginUser } = useContext(UserContext);

  const valid = useRef(new Map());

  UseValidation(valid);

  const isValid = () => ![...valid.current.values()].some((v) => v === false);

  const AccountSettingsFields = [
    {
      id: "id-input",
      name: "Id",
      type: "text",
      disabled: true,
      hoverText: 'non-editable field',
      defaultValue: user.id,
    },
    {
      id: "first-name-input",
      name: "First Name",
      type: "text",
      placeholder: "First Name",
      defaultValue: user.firstName,
      validationFunc: text_validation,
      onChange: () => {
        if (props.onChanged) props.onChanged(isValid());
      },
    },
    {
      id: "last-name-input",
      name: "Last Name",
      type: "text",
      placeholder: "Last Name",
      defaultValue: user.lastName,
      validationFunc: text_validation,
      onChange: () => {
        if (props.onChanged) props.onChanged(isValid());
      },
    },
    {
      id: "username-input",
      name: "Username",
      type: "text",
      placeholder: "Username",
      defaultValue: user.username,
      validationFunc: text_validation,
      onChange: () => {
        if (props.onChanged) props.onChanged(isValid());
      },
    },
    {
      id: "email-input",
      name: "Email",
      type: "email",
      placeholder: "email@example.com",
      defaultValue: user.email,
      validationFunc: email_validation,
      onChange: () => {
        if (props.onChanged) props.onChanged(isValid());
      },
    },
    {
      id: "phone-input",
      name: "Phone Number",
      type: "tel",
      placeholder: "555-555-5555",
      defaultValue: formatPhoneNumber(user.phone),
      maxLen: 12,
      disabled: true,
      hoverText: 'Update account phone number through multi-factor auth settings',
      validationFunc: phone_validation,
      onChange: (e) => {
        format_phone(e);
        if (props.onChanged) props.onChanged(isValid());
      },
    },
  ];

  return <DynamicForm id={"account-settings-form"} layout={[2, 3]} fields={AccountSettingsFields} />;
}
